import { formatNumberWithSuffix } from "~/utils/formatting"
import { validationStatusIcon } from "./OrgValidationReport"

interface ValidationReport {
  testResult: string
  testTitle: string
  testDescription: string
  oldValue?: number
  newValue?: number
}

interface ValidationReportDisplayProps {
  report: ValidationReport
}

export const ValidationReportDisplay: React.FC<ValidationReportDisplayProps> = ({ report }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="p-4 border border-base rounded-md">
        <div className="flex items-center gap-2 mb-2">
          {validationStatusIcon(report.testResult)}
          <div className="label-base">{report.testTitle}</div>
        </div>
        <p className="label-sm text-fg-subtle">{report.testDescription}</p>
        {report.oldValue !== undefined && report.newValue !== undefined && (
          <div className="mt-2 text-fg-subtle text-sm">
            <p>Current: {formatNumberWithSuffix(report.oldValue, 2)}</p>
            <p>New: {formatNumberWithSuffix(report.newValue, 2)}</p>
            <p>Difference: {formatNumberWithSuffix(report.newValue - report.oldValue, 2)}</p>
            <p>
              Percentage:{" "}
              {(((report.newValue - report.oldValue) / report.oldValue) * 100).toFixed(2)}%
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
